import * as angular from "angular";
import {IController} from "angular";

export class BringozFileDownloadButtonComponent implements IController {

  url: string;
  description?: string;

  constructor() {
  }

  $onInit() {}

  $onChanges(changes: angular.IOnChangesObject) {

  }

  downloadFile() {
    let downloadUrl = this.url;
    let a = document.createElement("a");
    a.href = downloadUrl;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozFileDownloadButton', {
    bindings: {
      url: '<',
      description: '<?'
    },
    template: require('./bringoz-file-download-button.html').default,
    controller: BringozFileDownloadButtonComponent
  });
